@if (authIsLoading$ | async) {
  <app-page-loader></app-page-loader>
} @else {
  <div class="app-content">
    <app-sidebar></app-sidebar>
    <div class="app-router-outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
  @if (companyThreadsOpened$ | async) {
    <app-company-threads @openCloseSidePanel></app-company-threads>
  }
  @if (documentRequestOpened$ | async) {
    <app-document-requests-panel @openCloseSidePanel></app-document-requests-panel>
  }
}
